export default __webpack_public_path__ + "static/media/b-5.5dc3ea75.png";